module.exports = __webpack_public_path__ + "static/media/book-nk-jemisin-black-future-month.4411b713.jpg";